import { Observable } from 'rxjs';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { IChatForm } from '@nimbus-global/features/chat-form/models/chat-form.model';
import { IChatFormFieldValidation } from '@nimbus-global/features/chat-form/models/chat-form-resolver.model';
import { IOptionItem } from '@nimbus-library/features/shared/models/interfaces/i-option-item';
import { CompanionReferenceType } from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { IChatFormEntityHandler } from './i-chat-form-entity-handler';

const REPORTING_MAX_LOOK_BACK_DAYS = 30;

const now = (): Date => new Date();
const maxLookBack = (): Date => {
  const date = now();
  date.setDate(date.getDate() - REPORTING_MAX_LOOK_BACK_DAYS);
  return date;
};

export class TeamChatFormEntityHandler implements IChatFormEntityHandler {
  public readonly entity = CompanionReferenceType.Team;

  public constructor(
    private readonly resolveTeamChatReferenceOptions: (
      referenceType: string,
      form: IChatForm,
      currentValues?: Record<string, unknown>,
    ) => Observable<IOptionItem[]>,
  ) {}

  public resolveReferenceOptions(
    referenceType: string,
    form: IChatForm,
    currentValues?: Record<string, unknown>,
  ): Observable<IOptionItem[]> {
    return this.resolveTeamChatReferenceOptions(referenceType, form, currentValues);
  }

  public resolveFieldTitle(field: string): TranslationKeys {
    switch (field) {
      case 'teamId':
        return TranslationKeys.GeneralService;
      case 'tenantId':
        return TranslationKeys.AdminCommonTenant;
      case 'fromUtc':
        return TranslationKeys.GeneralFrom;
      case 'toUtc':
        return TranslationKeys.GeneralTo;
      case 'atUtc':
        return TranslationKeys.GeneralAt;
      default:
        return TranslationKeys.GeneralName;
    }
  }

  public resolveFieldValidation(field: string): IChatFormFieldValidation | null {
    switch (field) {
      case 'fromUtc':
      case 'toUtc':
        return { minDate: maxLookBack, maxDate: now };
      case 'atUtc':
        return { minDate: maxLookBack };
      default:
        return null;
    }
  }
}
